import { Box, Link, Typography } from '@mui/material';
import React, { FC } from 'react';
import config from 'config/config';

interface SummaryLabelProps {
  labelText: string;
}

export const SummaryLabel: FC<SummaryLabelProps> = ({ labelText }) => {
  return (
    <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
      <Typography variant="h6">{labelText}:</Typography>
      <Link
        href={config.refundPolicyUrl}
        target="_blank"
        rel="noreferrer"
        sx={(theme) => ({
          color: theme.palette.text.primary,
          '&:hover': {
            color: theme.palette.text.primary,
          },
        })}
        variant="subtitle1"
      >
        Refund Policy
      </Link>
    </Box>
  );
};
